export default __webpack_public_path__ + "static/logo-m-18de310eb9fbcbe48abce2fded70b918.svg";